import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './about.css'; // 引入 CSS 文件

const About = () => {
  const [aboutText, setAboutText] = useState('');

  useEffect(() => {
    fetch('/assets/aboutUs.md')
      .then(response => response.text())
      .then(text => setAboutText(text))
      .catch(error => console.error('Error loading about page:', error));
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-800 max-w-screen-2xl mx-auto">

      <div className="flex-grow overflow-y-auto">
        <div className="container mx-auto px-4 py-12 max-w-4xl">
          <h1 className="text-3xl font-bold mb-6 text-gray-800">About Us</h1>
          <div className="prose max-w-none">
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={{
                a: ({ node, ...props }) => <a {...props} className="text-blue-600 hover:text-blue-500" />,
                p: ({ node, ...props }) => <p {...props} className="text-gray-600" />,
                h1: ({ node, ...props }) => <h1 {...props} className="text-gray-800 text-2xl font-bold mt-6 mb-4" />,
                h2: ({ node, ...props }) => <h2 {...props} className="text-gray-800 text-xl font-semibold mt-5 mb-3" />,
                h3: ({ node, ...props }) => <h3 {...props} className="text-gray-800 text-lg font-medium mt-4 mb-2" />,
                ul: ({ node, ...props }) => <ul {...props} className="list-disc list-outside text-gray-600 mb-4 ml-5" />,
                ol: ({ node, ...props }) => <ol {...props} className="list-decimal list-outside text-gray-600 mb-4" />,
                li: ({ node, ...props }) => <li {...props} className="mb-1" />,
                strong: ({ node, ...props }) => <strong {...props} className="font-bold text-gray-800" />,
              }}
            >
              {aboutText}
            </ReactMarkdown>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;